import React from 'react';
import Spinner from 'react-bootstrap/Spinner';
import { LoadingCardContainer } from './CardStyles';

const LoadingCard = ({ title }) => {
  return (
    <LoadingCardContainer>
      <div className="loading-content">
        <Spinner animation="border" variant="primary" />
        <div className="loading-text">
          {title}
        </div>
      </div>
    </LoadingCardContainer>
  );
};

export default LoadingCard;
